/* eslint-disable no-negated-condition */
/* eslint-disable unicorn/no-null */
/* eslint-disable func-names, no-unused-vars, no-undef, no-return-assign, unicorn/filename-case, angular/function-type, angular/controller-name, angular/controller-as */
;(function() {
  angular.module('app.ui.form.ctrls').controller('DatepickerDemoCtrl', [
    '$scope',
    '$location',
    '$log',
    function($scope, $location, $log) {
      var allowedUrlsForMonthFormat = new Set([
        '/profile',
        '/user-profile',
        '/profile#!',
        '/admin/lawyer-profile',
        '/admin/lawyer-listing',
      ])
      let oldDate = new Date()
      $scope.maxDate = new Date()
      $scope.today = function() {
        $scope.dt = new Date()
        $scope.dt.setHours(24, 0, 0, 0)
        oldDate.setDate(oldDate.getDate() + 1)
      }

      $scope.today()
      $scope.showWeeks = true
      $scope.toggleWeeks = function() {
        return ($scope.showWeeks = !$scope.showWeeks)
      }

      $scope.clear = function() {
        return ($scope.dt = null)
      }

      // $location;
      // $scope.disabled = function(date, mode) {
      //   if ($location.url() !== '/profile') {
      //     if (mode === 'month') {
      //       return mode === 'month' && date > $scope.dt
      //     }

      //     if (mode === 'day') {
      //       return mode === 'day' && date < $scope.dt
      //     }
      //   }
      // }

      $scope.reverseDisabled = function(date, mode) {
        if ($location.url() !== '/profile') {
          if (mode === 'month') {
            return mode === 'month' && date < $scope.dt
          }

          if (mode === 'day') {
            return mode === 'day' && date > oldDate
          }
        }
      }

      $scope.toggleMin = function() {
        var reference
        return ($scope.minDate =
          (reference = $scope.minDate) !== undefined
            ? reference
            : {
                null: new Date(),
              })
      }

      $scope.toggleMin()
      $scope.open = function(event) {
        event.preventDefault()
        event.stopPropagation()
        return ($scope.opened = true)
      }

      function isMonthFormatRequested(isMonthRequested) {
        const value = allowedUrlsForMonthFormat.has($location.path())

        console.debug(
          'DatePickerDemoCtrl.isMonthFormatRequested',
          isMonthRequested,
          value,
          $location.path()
        )
        return value
      }

      $scope.setPickerStyle = function(isMonthRequested) {
        if (isMonthFormatRequested(isMonthRequested)) {
          console.debug('DatePickerCtrl: detected month format')
          $scope.dateOptions = {
            'year-format': "'yy'",
            'starting-day': 1,
            'datepicker-mode': "'month'",
            'min-mode': 'month',
            defaultDate: '1',
          }
          $scope.formats = ['MMMM-yyyy', 'yyyy/MM', 'shortDate']
        } else {
          console.debug('DatePickerCtrl: detected day format')
          $scope.dateOptions = {
            'datepicker-mode': "'day'",
            'year-format': "'yy'",
            'starting-day': 1,
            defaultDate: '1',
          }
          $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM', 'shortDate']
        }

        return ($scope.format = $scope.formats[0])
      }

      $scope.setPickerStyle()
    },
  ])
})()



// WEBPACK FOOTER //
// ./scripts/shared/DatepickerDemoCtrl.js